<template>
    <div class="Details">
    <section>
        <div class="x">
            
            <div class="box" v-if="dataset.public == false || dataset.userId == currentUser.id">
              <b-navbar>
                    <template #start>
                        <b-navbar-item tag="div">
                          <h4 class="title is-5">Quality score:&nbsp;{{ dataset.label_score.toFixed(3)*1000 }}/1000</h4>
                          <!-- <div class="buttons">
                            
                            <b-field label="Filter">
                              <b-select placeholder="Select a filter" v-model="viewFilter">
                                <option value="all">All data</option>
                                <option value="labeled">Only labeled data</option>
                                <option value="unlabeled">Only unlabeled</option>
                                <option value="predicted">Only errors</option>

                                <optgroup label="Labels" >
                                    <option v-for="(n, col) in candidateLabels" :value="col">{{ col }}</option>
                                </optgroup>

                              </b-select>
                              &nbsp;
                            
                            
                          </b-field>
                          </div> -->
                        </b-navbar-item>
                        

                    </template>

                    <template #end>
                        <b-navbar-item tag="div">
                            <div class="buttons">
                              <b-button @click="isModalDatasetIncreaseOpen = true" class="is-info">
                            Add more text
                            </b-button>
                            <!-- <b-button @click="syntheticData" class="is-success">
                            Generate Synthetic Data
                            </b-button> -->
                            <b-button @click="startTraining()" class="is-info">
                            {{ (dataset.modelId != undefined)? 'Retrain AI Model':'Train AI Model' }}
                            </b-button>
                            <router-link v-if="(dataset.modelId != undefined)?true:false" type="button" class="is-info" :to="`/models/${dataset.modelId}/demo`">
                              Test Model
                            </router-link>
                            </div>
                        </b-navbar-item>
                    </template>
                </b-navbar>
                
            </div>
            
            <div class="box" v-if="datasetDocuments">
              
              <b-field grouped group-multiline>
              <div class="buttons">
                
                <b-button @click="changeView('all')" rounded :focused="viewFilter == 'all'"> 
                  All data
                  <b-tag rounded class="is-dark">{{ dataset.instances }}</b-tag>
                </b-button>

                <b-button @click="changeView('issues')" rounded :focused="viewFilter == 'issues'"> 
                  Label issues
                  <b-tag rounded class="is-danger">{{ totalLabelIssues() }}</b-tag>
                </b-button>
                
                <b-button @click="changeView(col)" :focused="viewFilter == col" v-if="candidateLabels" rounded v-for="(n, col) in this.candidateLabels" :value="col">{{ col }}<b-tag rounded> {{ n }}</b-tag></b-button>
                
              </div>
            
              </b-field>
            
              <br>
              <div class="columns is-gapless">
                <b-table 
                        :data="getData()" 
                        
                        :per-page="50"
                        :selected.sync="selected"
                        
                        paginated>
                        <b-table-column v-slot="props" >
                          <b-button @click="deleteData(props.row)" type="is-danger" class="is-small" v-if="selected.id==props.row.id">x</b-button>
                        </b-table-column>
                        
                        <b-table-column width="100%" field="text" label="Text" sortable searchable v-slot="props">
                          {{ props.row.text }}
                        </b-table-column>

                        <b-table-column field="label" label="Label" sortable searchable v-slot="props">
                            
                            <b-select placeholder="Select a label" 
                            @input="updateLabel(props.row)"
                            v-model="props.row.label">
                                <option
                                    v-for="(n, option) in candidateLabels"
                                    
                                    :value="option"
                                    >
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-table-column>

                        <b-table-column v-if="viewFilter=='issues'" field="predicted" label="Predicted" sortable searchable v-slot="props">
                          <b-tag size="is-medium">
                              <!-- <b-tag type="is-primary is-light">Pred</b-tag> -->
                              {{ (props.row.predicted!=undefined)?props.row.predicted:'' }}
                              </b-tag>
                        </b-table-column>
                        <b-table-column v-if="viewFilter=='issues'" field="quality" label="Label Quality" sortable v-slot="props">
                          
                              {{ (props.row.label_quality!=undefined)?props.row.label_quality.toFixed(2):'' }}
                          
                        </b-table-column>
                        
                        
                        
                    </b-table>
                  </div>
            </div>
            <b-skeleton v-else width="100%" :animated="true"></b-skeleton>
        </div>
        
    </section>

    <b-modal
        v-model="isModalModelCreateOpen"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Model"
        aria-modal
        scroll="keep">
        <template #default="props">
            <modal-model @close="props.close" :datasetData="dataset"></modal-model>
        </template>
    </b-modal>

    <b-modal
        v-model="isModalDatasetIncreaseOpen"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Dataset"
        aria-modal
        :width="840"
        scroll="keep">
        <template #default="props">
            <modal-dataset @close="props.close" :dataset="dataset"></modal-dataset>
        </template>
    </b-modal>
    </div>
    
</template>
<script>
import ModalDataset from '@/components/DatasetIncrease.vue'
import ModalModel from '@/components/ModelCreateNew.vue'
   export default {
     props: ["dataset", "wordclouds", "currentUser", "filterId"],
     name: "Data",
     data: function() {
    return {
        viewFilter: (this.$route.query.f == 'errors')?'issues':'all',
        viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
        versions: false,
        checkboxCustom: [],
        selected: {text: false, label: 'unlabeled'},
        newLabel: false,
        selectedVersion: 'v1',
        animated: true,
        candidateLabels: [],
        isModalDatasetIncreaseOpen: false,
        isModalModelCreateOpen: false,
        labelKeys: [],
        options: {
        
        },
        total: 0
    }},
    components: {
      ModalDataset,
      ModalModel
    },
    computed: {
      datasetDocuments() {
        //  let doc = this.$store.state.datasetDocuments;
         let doc = this.$store.state[`datasetDocuments-${this.dataset.id}`];
         
        //  this.totalLabelIssues = this.doc.filter(x => x.is_label_issue).length
         return doc
       }
     },
     methods: {
            openLoading() {
                    let isFullPage = true
                    const loadingComponent = this.$buefy.loading.open({
                        container: isFullPage ? null : this.$refs.element.$el
                    })
                    setTimeout(() => loadingComponent.close(), 5 * 1000)
            },
            startTraining() {
                this.isFinished = true
                
                this.openLoading()

                if(this.dataset.modelId!=undefined){
                  this.$buefy.notification.open('Retraining the model ' + this.dataset.name + ' Model')
                  this.retrainingModel()
                } else {
                  this.$buefy.notification.open('Training the model ' + this.dataset.name + ' Model')
                  this.createModel()
                }
    
            },
            async retrainingModel(){

              const result = await this.$store.dispatch("modelRetraining", this.dataset.modelId);
              
              setTimeout(() => 
                  this.$router.push('/models/'+newModelId+'/training'), 
              3.2 * 1000)
              
            },
            createModel() {

                const model = {
                    type: 'multi-class',
                    data_source: "data_source",
                    train_type: "train_type",
                    name: this.dataset.name + ' Model',
                    datasets: [this.dataset.id],
                    is_training: true
                }

                console.log(model)

                var newDoc = this.$store.dispatch("createModel",
                    model
                );

                

                newDoc.then(newModelId => {

                    this.assignModelToDataset(newModelId)

                    setTimeout(() => 
                        this.$router.push('/models/'+newModelId+'/training'), 
                    3.2 * 1000)
                })
                
            },
            assignModelToDataset(modelId){
                const toUpdate = {
                  datasetId: this.dataset.id,
                  update: {
                      modelId: modelId
                  }
                }
                this.$store.dispatch("updateDataset", 
                    toUpdate
                );
            },
          syntheticData() {
                this.$buefy.dialog.alert({
                    title: 'Generate Synthetic Data',
                    message: 'Synthetic data can be used to generate data samples for your dataset without data collection and labeling efforts. Its in experimental mode, please send us a request at support@metatext.io and we will enable for you!',
                    confirmText: 'Ok!'
                })
         },
         updateLabel(dataDoc){
            const toUpdate = {
              datasetId: this.dataset.id,
              docId: dataDoc.id,
              update: {
                label: dataDoc.label
              }
            }
            this.$store.dispatch("updateDatasetDocument", 
                toUpdate
            );
         },
         deleteData(dataDoc){
            const toDelete = {
              datasetId: this.dataset.id,
              docId: dataDoc.id,
            }
            this.$store.dispatch("deleteDatasetDocument", 
              toDelete
            );
         },
         selectFilters(){
          return [...viewOptions,...candidateLabels]
         },
         getFilter(item){
            
            // all, labeled, unlabeled, predicted
            if(this.viewFilter == 'issues'){
              return item.predicted != undefined;
            } else if(this.viewFilter == 'labeled'){
              return item.label != undefined && item.label != false;
            } else if(this.viewFilter == 'unlabeled'){
              return item.label == undefined || item.label == false;
            } else if(this.labelKeys.includes(this.viewFilter)){
              return item.label == this.viewFilter;
            } else {
              return true
            }
         },
         changeView(col){
           
           this.viewFilter = col
         },
         getData(){
            if(this.viewFilter != 'all'){
              return this.datasetDocuments.filter( 
                item => (
                  this.getFilter(item)
                )
              )
            } else {
              return this.datasetDocuments
            }
         },
         totalLabelIssues(){
            
            return (this.datasetDocuments!=undefined&&this.datasetDocuments!="")?this.datasetDocuments.filter(x => x.is_label_issue).length:0
         },
         unique(value, index, self) {
            return self.indexOf(value) === index
         },
         getModels(models){
            models.filter(unique)
         },
         selectCols(){
            return [
              {field: 'text', label: 'Text', searchable: true,},
              {field: 'label', label: 'Label', searchable: true},
              {field: 'predicted', label: 'Predicted', searchable: true},
              {field: 'predicted_proba', label: 'Predicted Confidence', searchable: false}
            ]
         }
     },
     created() {
        
        this.totalLabelIssues()

        this.viewFilter = (this.filterId!= undefined)?this.filterId:'all'
        this.$store.dispatch("getAllDatasetDocuments", {datasetId: this.dataset.id, filter: {view: this.viewFilter}});

        this.versions = [
          {id: 'v1', name: 'v1 ' + this.dataset.filename + ' created at '+ this.dataset.createdAt.toDate()}
        ]
        //this.$store.dispatch("currentDataset", this.datasetId);
        // if (this.dataset.labels.length) {
        //     this.candidateLabels = this.dataset.labels.sort((a,b) => a.localeCompare(b))
        // } else {
            // this.candidateLabels = this.dataset.labelBalance['labels']
        this.labelKeys = this.dataset.labelBalance['labels']
        var values = this.dataset.labelBalance['count']

        this.candidateLabels = {};
        this.labelKeys.forEach((key, i) => this.candidateLabels[key] = values[i]);
        //}

        
        
     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>